/* =====================================================
 * Eco Friendly Builder
 * Konfigurator for Eco Friendly produktside
 * Bygges av Wud / Christian (Apr 2026)
 * ===================================================== */
(function () {
  "use strict";

  const TAP_LABELS = {
    eco: "Eco", grohe: "Grohe", cosmo: "Cosmo", ares: "Ares",
    ecosoft: "Ecosoft", esla: "Esla", altea: "Altea", queen: "Queen", una: "Una"
  };

  const MODEL_LABELS = { light: "Light", standard: "Standard", plus: "Plus" };

  const MODEL_DESCRIPTIONS = {
    light: "Grunnmodellen — gir trygt drikkevann og stabil vannkvalitet. Perfekt der vannkvaliteten i utgangspunktet er god. Bruker keramisk sluttfilter for høy hygienisk kvalitet.",
    standard: "Bygger videre på Light med CW42-teknologi, hvor HP-filteret er en integrert del av filtreringen for høyere filtreringsgrad. Vår mest populære løsning.",
    plus: "Bygger videre på Standard med CW42-teknologi og har i tillegg partikkelfilter i forkant som beskytter systemet og forlenger levetiden. Anbefales ved partikler i vann (f.eks. brønnvann eller eldre rørsystemer)."
  };

  const TAP_TYPES = {
    separat: { key: "separat", label: "Separat drikkevannskran", desc: "En liten ekstra kran for filtrert vann ved siden av eksisterende kjøkkenkran." },
    treveis: { key: "treveis", label: "3-veis kjøkkenkran", desc: "Erstatter eksisterende kran. Varmt, kaldt og filtrert vann i én og samme kran." }
  };

  const state = {
    model: "standard",
    tapType: "treveis",
    tap: "altea",
    thumbIndex: 0,
    data: null
  };

  const fmt = (cents) => new Intl.NumberFormat("no-NO").format(Math.round(cents / 100)) + " kr";

  function init() {
    const dataEl = document.querySelector("[data-eco-friendly-data]");
    if (!dataEl) return;
    try {
      state.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    renderModels();
    renderTapTypes();
    renderTaps();
    renderModelInfo();
    renderImage();
    renderSummary();
    bindCompare();
    bindATC();
    bindQty();
    bindStickyBar();
  }

  function bindQty() {
    const input = document.getElementById("ef-qty");
    if (!input) return;
    document.querySelectorAll("[data-qty-step]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const step = parseInt(btn.dataset.qtyStep, 10);
        const v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
      });
    });
    input.addEventListener("change", () => {
      const v = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = v;
    });
  }
  function getQty() {
    const input = document.getElementById("ef-qty");
    return Math.max(1, parseInt(input?.value || "1", 10));
  }

  function renderModels() {
    const wrap = document.getElementById("ef-models");
    if (!wrap) return;
    wrap.innerHTML = "";
    Object.keys(MODEL_LABELS).forEach((mk) => {
      const m = state.data[mk];
      if (!m) return;
      const taps = m.taps || {};
      const prices = Object.values(taps).map((t) => t.price).filter((p) => typeof p === "number");
      const fromPrice = prices.length ? Math.min(...prices) : null;
      const isActive = state.model === mk;
      const tag = mk === "standard" ? '<span class="ef-model-card__tag">Mest valgt</span>' : "";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ef-model-card" + (isActive ? " is-active" : "");
      btn.dataset.model = mk;
      btn.innerHTML = `${tag}<div class="ef-model-card__name">${MODEL_LABELS[mk]}</div><div class="ef-model-card__price">${fromPrice != null ? "Fra " + fmt(fromPrice) : ""}</div>`;
      btn.addEventListener("click", () => selectModel(mk));
      wrap.appendChild(btn);
    });
    setText("ef-model-label", MODEL_LABELS[state.model]);
  }

  function selectModel(key) {
    state.model = key;
    if (!state.data[key].taps[state.tap]) {
      const allowed = TAP_TYPES[state.tapType] && state.data.tap_groups
        ? state.data.tap_groups[state.tapType] : Object.keys(state.data[key].taps);
      state.tap = allowed.find((t) => state.data[key].taps[t]) || Object.keys(state.data[key].taps)[0];
    }
    state.thumbIndex = 0;
    renderModels();
    renderTaps();
    renderModelInfo();
    renderImage();
    renderSummary();
  }

  function renderModelInfo() {
    setText("ef-model-info", MODEL_DESCRIPTIONS[state.model]);
  }

  function renderTapTypes() {
    const wrap = document.getElementById("ef-taptypes");
    if (!wrap) return;
    wrap.innerHTML = "";
    Object.values(TAP_TYPES).forEach((tt) => {
      const isActive = state.tapType === tt.key;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ef-taptype-card" + (isActive ? " is-active" : "");
      btn.dataset.taptype = tt.key;
      btn.innerHTML = `<div class="ef-taptype-card__name">${tt.label}</div><div class="ef-taptype-card__desc">${tt.desc}</div>`;
      btn.addEventListener("click", () => selectTapType(tt.key));
      wrap.appendChild(btn);
    });
    setText("ef-taptype-label", TAP_TYPES[state.tapType].label);
  }

  function selectTapType(key) {
    state.tapType = key;
    const allowed = state.data.tap_groups[key] || [];
    state.tap = allowed.find((t) => state.data[state.model].taps[t]) || allowed[0];
    state.thumbIndex = 0;
    renderTapTypes();
    renderTaps();
    renderImage();
    renderSummary();
  }

  function renderTaps() {
    const wrap = document.getElementById("ef-taps");
    if (!wrap) return;
    wrap.innerHTML = "";
    const allowed = state.data.tap_groups[state.tapType] || [];
    allowed.forEach((t) => {
      const v = state.data[state.model].taps[t];
      if (!v) return;
      const isActive = state.tap === t;
      const status = getStockStatus(v);
      const isOut = status.state === "out";
      const img = (v.images && v.images[0]) ? v.images[0].src : "";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ef-tap-card" + (isActive ? " is-active" : "") + (isOut ? " is-out" : "");
      btn.dataset.tap = t;
      const outBadge = isOut ? `<span class="ef-tap-card__badge">Utsolgt</span>` : "";
      btn.innerHTML = `
        ${outBadge}
        <div class="ef-tap-card__img">${img ? `<img src="${img}" alt="${TAP_LABELS[t]} kran" loading="lazy" />` : ""}</div>
        <div class="ef-tap-card__name">${TAP_LABELS[t]}</div>
        <div class="ef-tap-card__price">${fmt(v.price)}</div>
      `;
      btn.addEventListener("click", () => selectTap(t));
      wrap.appendChild(btn);
    });
    setText("ef-tap-label", TAP_LABELS[state.tap] || "");
  }

  function selectTap(t) {
    state.tap = t;
    state.thumbIndex = 0;
    renderTaps();
    renderImage();
    renderSummary();
  }

  function getCurrentVariant() {
    return state.data[state.model] && state.data[state.model].taps[state.tap];
  }

  function renderImage() {
    const v = getCurrentVariant();
    if (!v) return;
    const img = document.getElementById("ef-image");
    const badge = document.getElementById("ef-badge");
    const onSale = v.compare && v.compare > v.price;
    if (badge) {
      badge.textContent = onSale ? "Tilbud" : (state.model === "standard" ? "Mest valgt" : "");
      badge.style.display = badge.textContent ? "block" : "none";
      badge.style.background = onSale ? "var(--ef-c-sale, #E32619)" : "var(--ef-c-green, #4FA68C)";
    }
    const imgs = v.images || [];
    const main = imgs[state.thumbIndex] || imgs[0];
    if (img && main) {
      img.style.opacity = 0;
      setTimeout(() => {
        img.src = main.src;
        img.alt = main.alt || v.title;
        img.style.opacity = 1;
      }, 120);
    }
    const thumbs = document.getElementById("ef-thumbs");
    if (!thumbs) return;
    thumbs.innerHTML = "";
    imgs.slice(0, 5).forEach((im, i) => {
      const t = document.createElement("button");
      t.type = "button";
      t.className = i === state.thumbIndex ? "is-active" : "";
      t.innerHTML = `<img src="${im.src}" alt="${im.alt || ""}" loading="lazy" />`;
      t.addEventListener("click", () => { state.thumbIndex = i; renderImage(); });
      thumbs.appendChild(t);
    });
  }

  function renderSummary() {
    const v = getCurrentVariant();
    if (!v) return;
    const total = v.price;

    setText("ef-sum-total", fmt(total));

    const compareEl = document.getElementById("ef-sum-compare");
    if (compareEl) {
      if (v.compare && v.compare > total) {
        compareEl.textContent = fmt(v.compare);
        compareEl.hidden = false;
      } else compareEl.hidden = true;
    }

    const sub = document.getElementById("ef-sum-sub");
    if (sub) {
      if (v.compare && v.compare > total) {
        sub.innerHTML = `Du sparer <strong style="color:#E32619">${fmt(v.compare - total)}</strong>`;
      } else {
        sub.textContent = "Komplett pakke — alt inkludert";
      }
    }

    setText("ef-sku", v.sku || "—");

    setText("ef-sticky-title", `Eco Friendly ${MODEL_LABELS[state.model]} + ${TAP_LABELS[state.tap] || ""}`);
    setText("ef-sticky-price", fmt(total));

    renderStockUI(v);
    updateJudgeMe(v.product_id);
  }

  function getStockStatus(v) {
    if (v.available === false) {
      return { state: "out", label: "Utsolgt", canBuy: false };
    }
    const qty = v.inventory_qty;
    const policy = v.inventory_policy || "deny";
    if (qty != null && qty <= 0 && policy === "continue") {
      return { state: "backorder", label: "Bestillingsvare — sendes senere", canBuy: true };
    }
    if (qty != null && qty > 0 && qty <= 5) {
      return { state: "low", label: `Få igjen — kun ${qty} på lager`, canBuy: true };
    }
    return { state: "in_stock", label: "På lager", canBuy: true };
  }

  function renderStockUI(v) {
    const status = getStockStatus(v);

    const wrap = document.querySelector(".ef-meta .product-stock-level");
    if (wrap) {
      wrap.classList.remove("product-stock-level--in-stock", "product-stock-level--low-stock", "product-stock-level--none", "product-stock-level--backorder");
      const cls = {
        in_stock: "product-stock-level--in-stock",
        low: "product-stock-level--low-stock",
        backorder: "product-stock-level--backorder",
        out: "product-stock-level--none"
      }[status.state];
      if (cls) wrap.classList.add(cls);

      const badge = wrap.querySelector(".product-stock-level__badge-text");
      if (badge) badge.textContent = status.label;
    }

    const atc = document.getElementById("ef-atc");
    const stickyCta = document.querySelector(".ef-sticky-bar__cta");
    [atc, stickyCta].forEach((btn) => {
      if (!btn) return;
      if (status.canBuy) {
        btn.disabled = false;
        btn.classList.remove("is-disabled");
        if (btn === atc) btn.textContent = "Legg i handlekurv";
        if (btn === stickyCta) btn.textContent = "Legg i kurv";
      } else {
        btn.disabled = true;
        btn.classList.add("is-disabled");
        if (btn === atc) btn.textContent = "Utsolgt";
        if (btn === stickyCta) btn.textContent = "Utsolgt";
      }
    });
  }

  function updateJudgeMe(productId) {
    if (!productId) return;
    const badgeWrap = document.getElementById("ef-judgeme-badge");
    const reviewsWrap = document.getElementById("ef-judgeme-reviews");

    function swapWidget(wrap, widgetClass) {
      if (!wrap) return;
      const current = wrap.querySelector(".jdgm-widget");
      const currentId = current && current.getAttribute("data-id");
      if (String(currentId) === String(productId)) return;
      wrap.innerHTML = `<div class='jdgm-widget ${widgetClass}' data-id='${productId}' data-template='manual-installation'></div>`;
    }

    swapWidget(badgeWrap, "jdgm-preview-badge");
    swapWidget(reviewsWrap, "jdgm-review-widget");
    triggerJudgeMeRefresh();
  }

  let _judgeMeTimer = null;
  function triggerJudgeMeRefresh() {
    clearTimeout(_judgeMeTimer);
    _judgeMeTimer = setTimeout(() => {
      try {
        if (window.jdgm && typeof window.jdgm.preloadReviewBadge === "function") window.jdgm.preloadReviewBadge();
      } catch (e) {}
      try {
        if (window.jdgm && typeof window.jdgm.preloadReviewWidget === "function") window.jdgm.preloadReviewWidget();
      } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent("jdgm.refresh"));
        window.dispatchEvent(new CustomEvent("jdgm:refresh"));
      } catch (e) {}
      try {
        if (window.jdgmCacheServer && typeof window.jdgmCacheServer.reloadAll === "function") window.jdgmCacheServer.reloadAll();
      } catch (e) {}
    }, 100);
  }

  function bindCompare() {
    document.querySelectorAll("[data-pick]").forEach((b) => {
      b.addEventListener("click", () => {
        selectModel(b.dataset.pick);
        document.getElementById("eco-friendly-builder").scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function bindATC() {
    const atc = document.getElementById("ef-atc");
    if (!atc) return;
    atc.addEventListener("click", async () => {
      const v = getCurrentVariant();
      if (!v || !v.variant_id) {
        alert("Beklager — variant ikke tilgjengelig.");
        return;
      }
      const qty = getQty();
      const items = [{ id: v.variant_id, quantity: qty }];

      try {
        atc.disabled = true;
        atc.textContent = "Legger til...";
        const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || "/cart/add.js";
        const res = await fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || "/cart";
      } catch (err) {
        atc.disabled = false;
        atc.textContent = "Legg i handlekurv";
        alert("Kunne ikke legge i handlekurv: " + err.message);
      }
    });
  }

  function bindStickyBar() {
    const bar = document.getElementById("ef-sticky-bar");
    const atc = document.getElementById("ef-atc");
    if (!bar || !atc) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          bar.classList.remove("is-visible");
          bar.hidden = true;
        } else {
          bar.hidden = false;
          requestAnimationFrame(() => bar.classList.add("is-visible"));
        }
      });
    }, { threshold: 0 });
    observer.observe(atc);
  }

  function setText(id, text) {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
